// extracted by mini-css-extract-plugin
module.exports = {"root":"CardSwiper_root__Kvs6b","root--md":"CardSwiper_root--md__xBF4r","slider":"CardSwiper_slider__2Y9sn","rotation":"CardSwiper_rotation__uqFAf"};